/**
 * Calculates the next inspection due date based on the last inspected date
 * and the Ground Matrix Score.
 *  - Score >= 60 → next inspection in 3 months
 *  - Score < 60 or blank → next inspection in 6 months
 */
export function calculateNextInspectionDate(
  lastInspectedDate: string,
  groundMatrixScore?: number
): string {
  const date = new Date(lastInspectedDate);
  const months =
    groundMatrixScore !== undefined && groundMatrixScore >= 60 ? 3 : 6;
  date.setMonth(date.getMonth() + months);
  return date.toISOString().split('T')[0];
}

/** Formats a date string (YYYY-MM-DD) to display format (MMM D, YYYY) */
export function formatDate(dateStr?: string): string {
  if (!dateStr) return '—';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** Returns today as YYYY-MM-DD */
export function today(): string {
  return new Date().toISOString().split('T')[0];
}

/** Returns the year for a given date string, defaults to current year */
export function getYear(dateStr?: string): number {
  if (!dateStr) return new Date().getFullYear();
  return new Date(dateStr).getFullYear();
}

/** Returns the period (Q1–Q4) for a date string */
export function getPeriod(dateStr?: string): string {
  const month = dateStr
    ? new Date(dateStr).getMonth()
    : new Date().getMonth();
  if (month < 3) return 'Q1';
  if (month < 6) return 'Q2';
  if (month < 9) return 'Q3';
  return 'Q4';
}

/** Checks if a date is within the last N days */
export function isWithinDays(dateStr: string, days: number): boolean {
  const d = new Date(dateStr);
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - days);
  return d >= cutoff;
}

/** Generates a short unique local ID */
export function localId(): string {
  return `local_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}
